import { ColDef, GridOptions } from 'ag-grid-community';

// Start Ag grid default configuration
export const DEFAULT_AG_COL_DEF: ColDef = {
  filter: true,
  resizable: true,
  sortable: true
};

export const BASE_AG_GRID_OPTIONS: GridOptions = {
  defaultColDef: DEFAULT_AG_COL_DEF,
  suppressMenuHide: true,
  // onGridSizeChanged: (params) => {
  //   // params.api.sizeColumnsToFit()
  //   params.columnApi.autoSizeColumns
  // }
};

// End Ag grid default configuration